var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4994 14.55C39.7905 12.5991 38.8487 10.0936 38.8494 7.5H31.1244V38.5C31.0648 40.1776 30.3566 41.7665 29.1488 42.9323C27.9411 44.0981 26.328 44.7498 24.6494 44.75C21.0994 44.75 18.1494 41.85 18.1494 38.25C18.1494 33.95 22.2994 30.725 26.5744 32.05V24.15C17.9494 23 10.3994 29.7 10.3994 38.25C10.3994 46.575 17.2994 52.5 24.6244 52.5C32.4744 52.5 38.8494 46.125 38.8494 38.25V22.525C41.9819 24.7746 45.7428 25.9816 49.5994 25.975V18.25C49.5994 18.25 44.8994 18.475 41.4994 14.55Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4eb0b0b7a72dedd95e93ad62838bf0c6.svg";
export { ForwardRef as ReactComponent };